<template>
    <siteTeam :isTestPortal="true"></siteTeam>
  </template>
  <script>
  import siteTeam from "./site-team.vue";
  export default {
    name: "test-portal-site-team",
    components: {
        siteTeam
    }
  };
  </script>